import { render } from "./UnionLogin.vue?vue&type=template&id=769c7fb2"
import script from "./UnionLogin.vue?vue&type=script&lang=js"
export * from "./UnionLogin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Junior/ProjectPile/smartpile-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__